import '@/assets/css/style.css';

import { createApp } from 'vue'
import App from './App.vue';
import store from './store';
import router from '@/router/index.js';
import i18n from '@/i18n';
import './registerServiceWorker'

document.title = 'ORAL-FUNCTION-CHECK-APP';

store.$i18n = i18n.global;

const app = createApp(App);

app.use(store);
app.use(router);
app.use(i18n);
app.mount('#top-elm');
